


































































import { Vue, Component, Mixins, Prop } from 'vue-property-decorator';

import MyList from '@/mixins/list';

import Detail from './activity_detail.vue';

@Component({
  components: {
    Detail
  }
})
export default class extends Mixins(MyList) {
  @Prop({ default: 0 }) clubId!: number;

  dispatchType = "club/activities";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "类型", scopedSlots: { customRender: "activity_type" } },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "发起时间", dataIndex: "created_time" },
    { title: "发起人", scopedSlots: { customRender: "user_id" } },
    { title: "发起成功时间", dataIndex: "endtime" },
    { title: "参与人数", dataIndex: "usercount" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData({ club_id: this.clubId }, false);
  }
}
